import Box from 'components/ui/box';
import { DeletedTask } from 'services/dashboard.service';

import { DeletedTaskItem, DeletedTaskOwner } from './deleted-task-item';
import { DeletedSectionState } from './deleted-tasks';

interface Props {
  state: DeletedSectionState;
  items: DeletedTask[];
  owner: DeletedTaskOwner;
}

/** Seção abaixo do quadro da fase com as realizações que o próprio usuário excluiu (spec `realizacoes-excluidas`). */
export function DeletedTasksSection({ state, items, owner }: Props) {
  if (state === 'oculta') return null;

  return (
    <section className="mt-12">
      <h2 tabIndex={0} className="text-xl text-white block mb-6 font-semibold">
        Realizações Destaque excluídas
      </h2>

      <Box className="relative bg-prussian-blue border-electric-blue p-4 lg:p-8 border-opacity-100 bg-opacity-100 w-full rounded-[20px] space-y-4">
        {state === 'erro' ? (
          <p className="text-azureish-white/70 text-sm">Não foi possível carregar as realizações excluídas.</p>
        ) : (
          items.map(task => <DeletedTaskItem key={task._id} task={task} owner={owner} />)
        )}
      </Box>
    </section>
  );
}
